import React, {useEffect, useState} from "react";
import Toaster from "../common/ToastMsg";
import InventoryService from "../services/inventory.service";

const PartsPhoto = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const inventoryId = urlSearchParams.get("inventoryId");
    const [urls, setUrls] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        InventoryService.listPhotos(inventoryId).then(
            (response) => {
                setUrls(response.data);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                Toaster.error({
                    title: "Failed to load photos !",
                    text: error.message
                }, {
                    position: "top-center",
                    containerId: "search"
                });
                setLoading(false);
            }
        )

    }, []);

    // display the images in a grid layout with 4 images per row

    return (
        <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
            {loading && (
                <div className="text-center my-3">
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Loading photos...
                </div>
            )}
            <div className="row">
                {urls.map((url, index) => (
                    <div className="col-md-3" key={index}>
                        <img src={url} alt="part" className="img-thumbnail"/>
                    </div>
                ))}
            </div>
        </div>
    );

}

export default PartsPhoto;
